import $ from 'jquery';

export default function () {
    $('[data-change-form-action]').on('click', (function () {
        $(this).closest("form").attr("action", $(this).attr('data-change-form-action'));
    }));

    $('[data-change-form-action]').each(function () {
        $(this).removeAttr('disabled');
    });
}